import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerOrderReviews, getCustomerOrderPendingReviews, sendAdminReview } from "../../store/AsyncMethods/ProductMethod";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FaRegComments } from "react-icons/fa";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { useNavigate } from "react-router-dom";

const tools = [
  { label: "Quick Reply", desc: "Quick reply to your reviews", icon: "pi pi-send", color: "#E6F0FF" },
  { label: "Review Analysis Center", desc: "Know your reviews performance better", icon: "pi pi-chart-bar", color: "#E6F0FF" },
  { label: "External Review", desc: "Manage imported reviews to your store", icon: "pi pi-upload", color: "#E6F0FF" },
  { label: "Customer Question", desc: "Check and answer the questions from customers", icon: "pi pi-question-circle", color: "#FFF7E6" },
];

const reviewData = [
  {
    order: "218502537872656",
    product: {
      name: "Samyang Cheese Flavour Ramen (PACK OF 2) (YELLOW) 280 Gram Instant Noodles Korean Imported Noodles",
      id: "432818878",
      img: "https://dummyimage.com/64x64/cccccc/000000&text=No+Image",
    },
    rating: 5,
    expiration: "29 Day Left",
    reviewer: "Hunsa A.",
  },
  {
    order: "218463914836485",
    product: {
      name: "K-POP CHIPS GRILLED KEBAB 50G",
      id: "578529307",
      img: "https://dummyimage.com/64x64/cccccc/000000&text=No+Image",
    },
    rating: 5,
    expiration: "29 Day Left",
    reviewer: "Fatima F.",
  },
  {
    order: "218463317138130",
    product: {
      name: "Rice paper 22cm 340 Gram 33 Sheets Thuong Hang Imported Vietnam",
      id: "430676177",
      img: "https://dummyimage.com/64x64/cccccc/000000&text=No+Image",
    },
    rating: 5,
    expiration: "29 Day Left",
    reviewer: "Aasiya",
  },
  {
    order: "218463317138130",
    product: {
      name: "Rice paper 22cm 113 Gram 11 Sheets Thuong Hang Imported Vietnam",
      id: "434771155",
      img: "https://dummyimage.com/64x64/cccccc/000000&text=No+Image",
    },
    rating: 4.8,
    expiration: "29 Day Left",
    reviewer: "Aasiya",
  },
];

export default function CustomerOrderReviews() {
  const dispatch = useDispatch();
  const { customerOrderReviews, customerOrderPendingReviews, products } = useSelector(state => state.ProductReducer);
  const navigate = useNavigate();

  // Filter states
  const [productIdFilter, setProductIdFilter] = useState("");
  const [orderIdFilter, setOrderIdFilter] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  // Pagination states
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);

  const [showQuickReply, setShowQuickReply] = useState(false);
  const [quickReplyIndex, setQuickReplyIndex] = useState(0);
  const [quickReplyText, setQuickReplyText] = useState("");

  useEffect(() => {
    dispatch(getCustomerOrderReviews());
    dispatch(getCustomerOrderPendingReviews());
  }, [dispatch]);

  // Filtering logic
  const filteredReviews = customerOrderReviews.filter(row => {
    const matchesProductId = productIdFilter === "" || String(row.product_id).includes(productIdFilter);
    const matchesOrderId = orderIdFilter === "" || String(row.order_id).includes(orderIdFilter);
    let matchesStart = true, matchesEnd = true;
    if (startDate) {
      matchesStart = new Date(row.created_at) >= new Date(new Date(startDate).setHours(0,0,0,0));
    }
    if (endDate) {
      matchesEnd = new Date(row.created_at) <= new Date(new Date(endDate).setHours(23,59,59,999));
    }
    return matchesProductId && matchesOrderId && matchesStart && matchesEnd;
  });

  // Pagination logic
  const paginatedReviews = filteredReviews.slice(first, first + rows);

  // Calculate New today and Expire today
  const today = new Date();
  const newTodayCount = filteredReviews.filter(row => {
    const created = new Date(row.created_at);
    return created.toDateString() === today.toDateString();
  }).length;
  const expireTodayCount = filteredReviews.filter(row => {
    const created = new Date(row.created_at);
    const diffDays = Math.floor((today - created) / (1000 * 60 * 60 * 24));
    return diffDays === 30;
  }).length;

  // Calculate pending reply count and new/expire today for pending
  const pendingReplyCount = (customerOrderPendingReviews || []).filter(
    review => review.admin_review === null || review.admin_review === undefined || review.admin_review === ""
  ).length;
  const pendingNewTodayCount = (customerOrderPendingReviews || []).filter(review => {
    const created = new Date(review.created_at);
    return (
      (review.admin_review === null || review.admin_review === undefined || review.admin_review === "") &&
      created.toDateString() === today.toDateString()
    );
  }).length;
  const pendingExpireTodayCount = (customerOrderPendingReviews || []).filter(review => {
    const created = new Date(review.created_at);
    const diffDays = Math.floor((today - created) / (1000 * 60 * 60 * 24));
    return (
      (review.admin_review === null || review.admin_review === undefined || review.admin_review === "") &&
      diffDays === 30
    );
  }).length;

  // Product with Review Coverage calculation (with debug logging and type fix)
  const allProductIds = new Set((products || []).map(p => String(p.id)));
  const productIdsWithRatings = new Set(
    (customerOrderReviews || [])
      .filter(r => r.rating && r.rating > 0)
      .map(r => String(r.product_id))
  );
  const coverage = allProductIds.size > 0
    ? ((productIdsWithRatings.size / allProductIds.size) * 100).toFixed(1)
    : "0.0";
  // Debug log
  console.log({
    allProductIds: Array.from(allProductIds),
    productIdsWithRatings: Array.from(productIdsWithRatings),
    products,
    customerOrderReviews
  });

  // Positive Seller Rating calculation
  const allRatedReviews = (customerOrderReviews || []).filter(
    r => r.rating && r.rating > 0
  );
  const positiveRatedReviews = allRatedReviews.filter(
    r => r.rating === 4 || r.rating === 5
  );
  const positiveSellerRating = allRatedReviews.length > 0
    ? ((positiveRatedReviews.length / allRatedReviews.length) * 100).toFixed(1)
    : "0.0";

  // Filter for pending replies
  const pendingReplies = (customerOrderPendingReviews || []).filter(
    review => review.admin_review === null || review.admin_review === undefined || review.admin_review === ""
  );

  // Handle reply submit
  const handleQuickReply = async () => {
    const currentReview = pendingReplies[quickReplyIndex];
    if (!currentReview) return;
    const payload = { id: currentReview.review_id, adminReview: quickReplyText };
    const success = await dispatch(sendAdminReview(payload));
    if (success) {
      await dispatch(getCustomerOrderPendingReviews());
      await dispatch(getCustomerOrderReviews());
      setQuickReplyText("");
      if (quickReplyIndex < pendingReplies.length - 1) {
        setQuickReplyIndex(quickReplyIndex + 1);
      } else {
        setShowQuickReply(false);
        setQuickReplyIndex(0);
      }
    }
  };

  // Handle Enter key
  const handleQuickReplyKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey && quickReplyText.trim()) {
      e.preventDefault();
      handleQuickReply();
    }
  };

  // Reset index when opening/closing
  useEffect(() => {
    if (showQuickReply) setQuickReplyIndex(0);
    setQuickReplyText("");
  }, [showQuickReply]);

  // Performance card data (dynamic count)
  const performanceData = [
    {
      title: "To be Reviewed",
      value: filteredReviews.length,
      sub: `New today: ${newTodayCount}\nExpire today: ${expireTodayCount}`,
      color: "#FF6A00",
    },
    {
      title: "Pending Reply to Reviews",
      value: pendingReplyCount,
      sub: `New today: ${pendingNewTodayCount}\nExpire today: ${pendingExpireTodayCount}`,
      color: "#FF6A00",
      button: <Button label="Quick Reply" className="p-button-sm p-button-secondary p-primary-btn ml-2 h-4" onClick={() => setShowQuickReply(true)} />,
    },
    {
      title: "Product with Review Coverage",
      value: `${coverage}%`,
      sub: "Target Rate 92.0%",
      color: "#FF6A00",
      progress: Number(coverage),
      target: 92,
    },
    {
      title: "Positive Seller Rating",
      value: `${positiveSellerRating}%`,
      sub: "Target Rate 92.0%",
      color: "#FF6A00",
      progress: Number(positiveSellerRating),
      target: 92,
    },
  ];

  return (
    <div className="p-6">
      <div className="text-xs text-gray-400 mb-2">Home &gt; Orders &gt; Reviews</div>
      <h2 className="text-2xl font-bold mb-4">Reviews Management</h2>
      {/* Performance Overview */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
        {performanceData.map((item, idx) => (
          <Card key={idx} className="shadow-sm rounded-xl" style={{ background: "#FFF8F2" }}>
            <div className="flex flex-col gap-2">
              <div className="text-gray-500 text-sm font-semibold mb-1">{item.title}</div>
              <div className="flex items-center gap-2">
                <span className="text-4xl font-extrabold" style={{ color: item.color }}>{item.value}</span>
                {item.button && <Button label={item.button} className="p-button-sm p-button-warning ml-2" />}
              </div>
              <div className="text-xs text-gray-500 whitespace-pre-line">{item.sub}</div>
              {item.progress !== undefined && (
                <div className="mt-2">
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div
                      className="h-2 rounded-full"
                      style={{ width: `${item.progress}%`, background: item.barColor || '#FFB300' }}
                    ></div>
                  </div>
                </div>
              )}
            </div>
          </Card>
        ))}
      </div>
      {/* Tools */}
      <div className="mb-6">
        <div className="font-bold text-lg mb-2">Tools</div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          {tools.map((tool, idx) => (
            <Card
              key={idx}
              className="shadow-sm rounded-xl hover:shadow-md transition cursor-pointer"
              style={{ background: tool.color }}
              onClick={
                tool.label === "Customer Question"
                  ? () => navigate("/customer-questions")
                  : tool.label === "Review Analysis Center"
                  ? () => navigate("/review-analysis-center")
                  : undefined
              }
            >
              <div className="flex items-center gap-3 py-2">
                <i className={`${tool.icon} text-3xl`} />
                <div>
                  <div className="font-semibold text-base mb-1">{tool.label}</div>
                  <div className="text-xs text-gray-600">{tool.desc}</div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
      {/* Tab Bar */}
      <div className="flex items-end gap-2 border-b mb-4">
        <span className="text-gray-500 font-semibold text-base mb-1">Product's Review Detail</span>
        <span className="text-orange-500 font-semibold text-base mb-1 border-b-2 border-orange-500 pb-1 ml-2">To be Reviewed</span>
      </div>
      {/* Filters */}
      <div className="flex flex-wrap items-center gap-3 mb-4 bg-gray-50 p-4 rounded-lg justify-between">
        <div className="flex flex-wrap gap-3 items-center">
          <InputText placeholder="Product ID" className="w-48" value={productIdFilter} onChange={e => setProductIdFilter(e.target.value)} />
          <InputText placeholder="Order ID" className="w-48" value={orderIdFilter} onChange={e => setOrderIdFilter(e.target.value)} />
          <Calendar placeholder="Start Date" className="min-w-[140px] w-40" style={{ minWidth: 140, width: 160 }} value={startDate} onChange={e => setStartDate(e.value)} />
          <span>-</span>
          <Calendar placeholder="End Date" className="min-w-[140px] w-40 bg-white" style={{ minWidth: 140, width: 160, background: 'white' }} value={endDate} onChange={e => setEndDate(e.value)}  />
        </div>
        <Button label="Reset" className="p-button-secondary p-button-sm" onClick={() => { setProductIdFilter(""); setOrderIdFilter(""); setStartDate(null); setEndDate(null); }} disabled={!(productIdFilter || orderIdFilter || startDate || endDate)} />
      </div>
      {/* Review Table */}
      <div className="bg-white rounded-xl shadow-sm p-2">
        <DataTable value={paginatedReviews} className="rounded-lg" showGridlines responsiveLayout="scroll"
          paginator paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          rows={rows} first={first} totalRecords={filteredReviews.length}
          onPage={e => { setFirst(e.first); setRows(e.rows); }}
          rowsPerPageOptions={[5, 10, 20, 50]}
        >
          <Column
            header="Product Quality"
            body={rowData => (
              <div className="flex items-center gap-3 py-2">
                <div>
                  <div className="font-semibold text-gray-800 text-sm mb-1">{rowData.title}</div>
                  <div className="text-xs text-gray-500">Product ID: {rowData.product_id}</div>
                  <div className="text-xs text-blue-600 mt-1">Order: {rowData.order_id}</div>
                </div>
              </div>
            )}
          />
          <Column
            header="Product Quality Score"
            body={rowData => (
              !rowData.rating ? (
                <span className="text-gray-400 italic">No rating yet</span>
              ) : (
                <div className="flex items-center gap-1">
                  <span className="font-bold text-base">Overall Rating {rowData.rating}</span>
                  <span className="text-yellow-500">
                    {Array.from({ length: Math.floor(rowData.rating) }).map((_, i) => (
                      <i key={i} className="pi pi-star-fill"></i>
                    ))}
                    {rowData.rating % 1 !== 0 && <i className="pi pi-star-half"></i>}
                  </span>
                </div>
              )
            )}
          />
          <Column
            header="Expiration Date"
            body={rowData => {
              const created = new Date(rowData.created_at);
              const now = new Date();
              const diffDays = Math.floor((now - created) / (1000 * 60 * 60 * 24));
              if (diffDays < 30) {
                return <span>{30 - diffDays} Day{30 - diffDays !== 1 ? 's' : ''} Left</span>;
              } else {
                return <span className="text-red-500 font-semibold">Expired</span>;
              }
            }}
          />
          <Column field="reviewer_name" header="Reviewer" />
        </DataTable>
      </div>
      <Dialog header="Quick Reply" visible={showQuickReply} style={{ width: '40vw', maxWidth: 600 }} onHide={() => setShowQuickReply(false)} modal>
        {pendingReplies.length === 0 ? (
          <div className="text-gray-500 text-center">No pending replies!</div>
        ) : (
          <div className="flex flex-col items-center">
            {/* Progress bar */}
            <div className="w-full flex items-center justify-between mb-2">
              <span className="text-xs text-gray-400">{quickReplyIndex + 1}/{pendingReplies.length}</span>
              <div className="flex-1 mx-2 bg-gray-200 rounded-full h-1 relative">
                <div className="h-1 rounded-full bg-gray-400" style={{ width: `${((quickReplyIndex + 1) / pendingReplies.length) * 100}%` }}></div>
              </div>
              <span className="text-xs text-gray-400">275</span>
            </div>
            {/* Review info */}
            <div className="w-full text-center mb-2">
              <span className="font-bold">Buyer Main Review</span> : {pendingReplies[quickReplyIndex].review}
              <div className="text-xs text-gray-500 mt-1">Created Time: {new Date(pendingReplies[quickReplyIndex].created_at).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}</div>
            </div>
            {/* Reply box */}
            <div className="w-full flex items-center gap-2">
              <Button icon="pi pi-chevron-left" className="p-button-text" disabled={quickReplyIndex === 0} onClick={() => setQuickReplyIndex(i => Math.max(0, i - 1))} />
              <div className="flex-1">
                <InputTextarea
                  autoResize
                  value={quickReplyText}
                  onChange={e => setQuickReplyText(e.target.value.slice(0, 500))}
                  onKeyDown={handleQuickReplyKeyDown}
                  rows={3}
                  maxLength={500}
                  placeholder='Press the "Enter" button to quickly reply'
                  className="w-full text-lg"
                />
                <div className="flex justify-between text-xs text-gray-400 mt-1">
                  <span></span>
                  <span>{quickReplyText.length}/500</span>
                </div>
              </div>
              <Button icon="pi pi-chevron-right" className="p-button-text" disabled={quickReplyIndex === pendingReplies.length - 1} onClick={() => setQuickReplyIndex(i => Math.min(pendingReplies.length - 1, i + 1))} />
            </div>
            <Button
              label="Reply"
              className="mt-4 w-full"
              disabled={!quickReplyText.trim()}
              onClick={handleQuickReply}
            />
          </div>
        )}
      </Dialog>
    </div>
  );
} 